import {forwardRef, ReactNode, TextareaHTMLAttributes} from 'react'
import {DefaultNamespace} from 'react-i18next'
import {
    StyledTextarea,
    StyledTextareaContainer,
    StyledTextareaGrid,
    StyledTextareaWrapper
} from 'src/components/textarea/style.ts'
import {InputHelpText} from 'src/components/input-help-text/InputHelpText'
import {Label} from 'src/components/label/Label'

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    className?: string
    label?: string | DefaultNamespace
    name?: string
    typeIcon?: ReactNode
    touched?: boolean
    errorMessage?: string | DefaultNamespace
    helpText?: string | DefaultNamespace
    placeholder?: string
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
    (
        {label, name, typeIcon, touched = false, errorMessage, helpText, className, disabled, placeholder, ...rest},
        ref
    ) => {
        return (
            <StyledTextareaContainer className={className}>
                {label && <Label htmlFor={name}>{label}</Label>}
                <StyledTextareaGrid>
                    <StyledTextareaWrapper touched={touched} hasError={!!errorMessage} disabled={disabled}>
                        {typeIcon}
                        <StyledTextarea ref={ref} name={name} placeholder={placeholder} disabled={disabled} {...rest} />
                    </StyledTextareaWrapper>
                </StyledTextareaGrid>
                {/*help text*/}
                <InputHelpText error={errorMessage} helpText={helpText} />
            </StyledTextareaContainer>
        )
    }
)

TextArea.displayName = 'TextArea'
